import { render, staticRenderFns } from "./averageEngagement.vue?vue&type=template&id=ab8ca554&"
import script from "./averageEngagement.vue?vue&type=script&lang=js&"
export * from "./averageEngagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports